import React from "react";
import IOText from "../ReUableComponents/ImageOntext";
import CBanner from "../Assessts/Images/CBanner.png";
import "../Assessts/Styles/ContactUs.scss";
import { IoLogoWhatsapp } from "react-icons/io";
const ContactUs = () => {
    return (
        <>
            <div className="Single_Banner mt-2">
                <IOText Image={CBanner} Alt="EMpower" Text={<div className="Text-MainDiv w-100" >
                    <div ><span style={{ color: "#F7D670" }}>Connect With Us </span>for <span style={{ color: "#F7D670" }}>Scholarship-Related Assistance</span> and Information.</div>
                </div>} />
            </div>
            <div className="Web-MainHeading mt-3">Contact Us – Customer Assistance</div>

            <div className="dflex gap-3 JCCenter ContactUs-Details mb-4">
                <div className="dflex gap-3  flexd-column">
                    <span className="dflex ">
                        <p>Active working hours - 10:00 AM - 5:30 PM  (Monday to Friday)</p>
                        <p><IoLogoWhatsapp /> 9494011166</p>
                    </span>
                    <span className="Web-SubHeading">indiascholarships@northsouth.org</span>
                </div>

            </div>
        </>
    )
}
export default ContactUs;